function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import { AlertInformation } from 'moduleBase/components/alert-information/AlertInformation';
import { useLocation } from 'react-router';
import app from 'srcJs/App';

var AlertInformationList = function AlertInformationList(_ref) {
  var alerts = _ref.alerts;

  var _useState = useState(alerts),
      _useState2 = _slicedToArray(_useState, 2),
      filteredAlerts = _useState2[0],
      setFilteredAlerts = _useState2[1];

  var location = useLocation();
  useEffect(function () {
    var pathNameWithoutLang = location.pathname;
    var langForPathname = "/".concat(app.getLang());

    if (location.pathname.startsWith(langForPathname)) {
      pathNameWithoutLang = location.pathname.substring(langForPathname.length);
    }

    setFilteredAlerts(function () {
      return alerts.filter(function (alert) {
        if (!alert.pages) {
          return true;
        }

        return alert.pages.some(function (page) {
          return page === pathNameWithoutLang;
        });
      });
    });
  }, [location.pathname]);
  var list = filteredAlerts.map(function (alert) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: alert.key
    }, /*#__PURE__*/React.createElement(AlertInformation, {
      keyProp: alert.key,
      content: alert.content,
      variant: alert.variant,
      closeUrl: alert.closeUrl,
      modalHeader: alert.modalHeader,
      modalContent: alert.modalContent,
      modalKey: alert.modalKey,
      leftButtonText: alert.leftButtonText,
      leftButtonUrl: alert.leftButtonUrl,
      rightButtonText: alert.rightButtonText,
      rightButtonUrl: alert.rightButtonUrl
    }));
  });
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-useless-fragment
    React.createElement(React.Fragment, null, list)
  );
};

export { AlertInformationList };